import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { admin_apiEndpoint, config_variable, sessionToken } from '../../helper/commonApi';
import { ApiCall, GetApiCall } from '../../helper/axios';

export const generateToken = createAsyncThunk('fetch/generateToken', async () => {
    console.log(sessionToken, 'sessionToken')
    const res = await ApiCall('POST', '/generate-token', { shop: config_variable.shop_name }, { authentication: sessionToken })
    console.log(res)
    if (res.data.status === 'success' && res.data.statusCode === 200) {
        return res?.data?.data;
    } else {
        if (window.location.hostname !== 'localhost') {
            window.parent.location.href = `${admin_apiEndpoint}?shop=${config_variable.shop_name}&host=${config_variable?.config.host}`;
        }
    }
});

export const createSettingAsync = createAsyncThunk('fetch/createSetting', async (param, thunkAPI) => {
    const state = thunkAPI.getState();
    const store_data = state?.commonData?.store_data;
    const res = await ApiCall('POST', `/settings?shop=${config_variable.shop_name}`, param?.payload, { authentication: store_data?.token })
    if (res.data.success && res.status === 200) {
        if (param.callback) {
            param.callback(res.data.success, res.data.message);
        }
        return res?.data?.data;
    } else {
        if (window.location.hostname !== 'localhost') {
            window.parent.location.href = `${admin_apiEndpoint}?shop=${config_variable.shop_name}&host=${config_variable?.config.host}`;
        }
    }
});

export const getSettingAsync = createAsyncThunk('fetch/getSetting', async (param, thunkAPI) => {
    const state = thunkAPI.getState();
    const store_data = state?.commonData?.store_data;
    const res = await GetApiCall('GET', `/settings?shop=${config_variable.shop_name}`, { authentication: store_data?.token })
    if (res.data.success && res.status === 200) {
        if (param.callback) {
            param.callback(res?.data?.data);
        }
        return res?.data;
    } else {
        if (window.location.hostname !== 'localhost') {
            window.parent.location.href = `${admin_apiEndpoint}?shop=${config_variable.shop_name}&host=${config_variable?.config.host}`;
        }
    }
});

export const getActivityLogsAsync = createAsyncThunk('fetch/getActivityLogs', async (param, thunkAPI) => {
    const state = thunkAPI.getState();
    const store_data = state?.commonData?.store_data;
    const params = new URLSearchParams({
        shop: config_variable.shop_name,
    });
    
    // Add pagination parameters
    if (param?.page) {
        params.append('page', param.page);
    }
    if (param?.limit) {
        params.append('limit', param.limit);
    }
    if (param?.search) {
        params.append('search', param.search);
    }
    
    const res = await GetApiCall('GET', `/activityLog/get?${params.toString()}`, { authentication: store_data?.token })
    if (res.data.success && res.status === 200) {
        if (param.callback) {
            param.callback(res?.data);
        }
        return res?.data;
    } else {
        if (window.location.hostname !== 'localhost') {
            window.parent.location.href = `${admin_apiEndpoint}?shop=${config_variable.shop_name}&host=${config_variable?.config.host}`;
        }
    }
});

export const getAnalyticsAsync = createAsyncThunk('fetch/getAnalytics', async (param, thunkAPI) => {
    const state = thunkAPI.getState();
    const store_data = state?.commonData?.store_data;
    const params = new URLSearchParams({
        shop: config_variable.shop_name,
    });
    
    // Only add date parameters if they exist and are valid Date objects
    if (param?.start && param.start instanceof Date && !isNaN(param.start.getTime())) {
        params.append('start', param.start.toISOString());
    }
    if (param?.end && param.end instanceof Date && !isNaN(param.end.getTime())) {
        params.append('end', param.end.toISOString());
    }
    
    const res = await GetApiCall('GET', `/activityLog/analytics?${params.toString()}`, { authentication: store_data?.token })
    if (res.data.success && res.status === 200) {
        if (param.callback) {
            param.callback(res?.data?.data);
        }
        return res?.data;
    } else {
        // if (window.location.hostname !== 'localhost') {
        //     window.parent.location.href = `${admin_apiEndpoint}?shop=${config_variable.shop_name}&host=${config_variable?.config.host}`;
        // }
    }
});

export const getSubscriptionAsync = createAsyncThunk('fetch/getSubscription', async (param, thunkAPI) => {
    const state = thunkAPI.getState();
    const store_data = state?.commonData?.store_data;
    const res = await ApiCall('GET', `/subscription?shop=${config_variable.shop_name}`, {}, { authentication: store_data?.token })
    if (res.status === 200) {
        if (param.callback) {
            param.callback(res.data.status === 'success');
        }
        return res?.data?.data;
    } else {
        if (window.location.hostname !== 'localhost') {
            window.parent.location.href = `${admin_apiEndpoint}?shop=${config_variable.shop_name}&host=${config_variable?.config.host}`;
        }
    }
});


const commonSlice = createSlice({
    name: 'common',
    initialState: {
        store_data: {},
        status: false,
        isError: false,
        activeModal: false,
        isGetSettingLoading: false,
        isCreateSettingLoading: false,
        settings: null,
        analytics: {
            totalData: null,
            filterData: null
        },
        isSubscriptionLoading: false,
        isAnalyticsLoading: false,
        isEmbedEnabled: false,
        activityLogs: {
            data: [],
            page: 1,
            limit: 10,
            total: 0,
            totalPages: 0
        },
        isActivityLogsLoading: false
    },
    extraReducers: (builder) => {
        builder
            .addCase(generateToken.pending, (state) => {
                state.status = false;
            })
            .addCase(generateToken.fulfilled, (state, { payload }) => {
                if (payload) {
                    const { shop_data, token } = payload;
                    state.store_data = { shop_data, token };
                    state.status = true;
                }
            })
            .addCase(generateToken.rejected, (state) => {
                state.isError = false;
                if (window.location.hostname !== 'localhost') {
                    window.parent.location.href = `${admin_apiEndpoint}?shop=${config_variable.shop_name}&host=${config_variable?.config.host}`;
                }
            })
            .addCase(getSettingAsync.pending, (state) => {
                state.isGetSettingLoading = true;
            })
            .addCase(getSettingAsync.fulfilled, (state, { payload }) => {
                state.isGetSettingLoading = false;
                if (payload) {
                    state.settings = payload?.data;
                    state.isEmbedEnabled = payload?.appEmbedStatus;
                }
            })
            .addCase(getSettingAsync.rejected, (state) => {
                state.isGetSettingLoading = false;
                state.isEmbedEnabled = false;
                if (window.location.hostname !== 'localhost') {
                    window.parent.location.href = `${admin_apiEndpoint}?shop=${config_variable.shop_name}&host=${config_variable?.config.host}`;
                }
            })
            .addCase(createSettingAsync.pending, (state) => {
                state.isCreateSettingLoading = true;
            })
            .addCase(createSettingAsync.fulfilled, (state) => {
                state.isCreateSettingLoading = false;
            })
            .addCase(createSettingAsync.rejected, (state) => {
                state.isCreateSettingLoading = false;
                if (window.location.hostname !== 'localhost') {
                    window.parent.location.href = `${admin_apiEndpoint}?shop=${config_variable.shop_name}&host=${config_variable?.config.host}`;
                }
            })
            .addCase(getSubscriptionAsync.pending, (state) => {
                state.isSubscriptionLoading = true;
            })
            .addCase(getSubscriptionAsync.fulfilled, (state, { payload }) => {
                state.isSubscriptionLoading = false;
                console.log(payload)
                if (payload) {
                    window.top.location.href = payload;
                }
            })
            .addCase(getSubscriptionAsync.rejected, (state) => {
                state.isSubscriptionLoading = false;
                if (window.location.hostname !== 'localhost') {
                    window.parent.location.href = `${admin_apiEndpoint}?shop=${config_variable.shop_name}&host=${config_variable?.config.host}`;
                }
            })
            .addCase(getAnalyticsAsync.pending, (state) => {
                state.isAnalyticsLoading = true;
            })
            .addCase(getAnalyticsAsync.fulfilled, (state, { payload }) => {
                state.isAnalyticsLoading = false;
                if (payload) {
                    state.analytics = { filterData: payload?.filteredData, totalData: payload?.totalData }
                }
            })
            .addCase(getAnalyticsAsync.rejected, (state) => {
                state.isAnalyticsLoading = false;
                state.analytics = {
                    filterData: null,
                    totalData: null
                }
                // if (window.location.hostname !== 'localhost') {
                //     window.parent.location.href = `${admin_apiEndpoint}?shop=${config_variable.shop_name}&host=${config_variable?.config.host}`;
                // }
            })
            .addCase(getActivityLogsAsync.pending, (state) => {
                state.isActivityLogsLoading = true;
            })
            .addCase(getActivityLogsAsync.fulfilled, (state, { payload }) => {
                state.isActivityLogsLoading = false;
                if (payload) {
                    state.activityLogs = {
                        data: payload.data || [],
                        page: payload.page || 1,
                        limit: payload.limit || 10,
                        total: payload.total || 0,
                        totalPages: payload.totalPages || 0
                    };
                }
            })
            .addCase(getActivityLogsAsync.rejected, (state) => {
                state.isActivityLogsLoading = false;
                state.activityLogs = {
                    data: [],
                    page: 1,
                    limit: 10,
                    total: 0,
                    totalPages: 0
                };
            });
    },
    reducers: {
        commonSliceData: (state, action) => {
            state.store_data = action.payload;
        },
        updateModalStatus: (state, action) => {
            state.activeModal = action.payload;
        }
    },
});
export const { updateSliceData, updateModalStatus } = commonSlice.actions;
export const getAllSetting = (state) => state.commonData;
export default commonSlice.reducer;
